/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class LoginApi {
    static getInstance() {
        if (!this.instance) this.instance = new LoginApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 登录
    async login (param){
        let url = `/api/auth/access_token/backend`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 登录时获取租户列表
    async getTenantList(user_id){
        let url = `/api/auth/backend/tenant/${user_id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 登录后获取品牌列表
    async loginByTenant(param, user_id, tenant_id){
        let url = `/api/auth/tenant/${user_id}/${tenant_id}`
        let result = await this.getData(url,param,'GET')
        return result
    }


    // 发送邮件 
    async resendEmail (id){
        let url = `/api/users/${id}/backend/resend_email`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 重置密码发送验证码到邮箱 
    async getValidCode (email){
        let url = `/api/users/${email}/send_captcha/backend`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 校验验证码 
    async checkVaildCode (code){
        let url = `/api/users/${code}/verify_captcha/backend`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 重置密码 
    async resetPwd (param){
        let url = `/api/users/reset_pwd/backend`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 重新发送账号激活邮件
    async resendActiveEmail (param, id){
        let url = `/api/v1/users/${id}/resend_email`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取用户头像
    async getUserAvatar (id){
        let url = `/api/users/backend/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // reqGet
    async reqGet (param){
        let url = `/api/captcha/get`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // reqCheck
    async reqCheck (param){
        let url = `/api/captcha/check`
        let result = await this.getData(url,param,'POST')
        return result
    }
    
}

export {
    LoginApi
}